import { axiosAccess, axiosDocument } from "@config/axiosConfig";
import { PreviewPayload, UploadedDocumentsPayload } from "../../types";

export const previewResponse = async (payload: PreviewPayload) => {
  const { access_id } = payload;
  return await axiosAccess.get(`/preview/${access_id}`, {});
};

export const uploadedDocuments = async (payload: any) => {
  const { access_id, module_type, category_id } = payload;
  return await axiosDocument.get(`/uploaded-files/${access_id}?application_type_id=${category_id}&module_type=${module_type}`, {});
};
